import React, { useCallback } from "react";
import { useChartOfAccountsQuery } from "@api/accountingReports.api";
import { Checkbox } from "@design-system/Checkbox/Checkbox";
import { Separator } from "@design-system/Separator/Separator";
import { TransactionCoaFilterType } from "@common/helpers/transactions";
import { BaseFilterProps } from "../../lib";
import { CoaAccountList } from "./CoaAccountList";
import styles from "./CoaAccountFilter.module.scss";

const coaFilterSettings = [
    { label: "Member", option: TransactionCoaFilterType.USER },
    { label: "Rule", option: TransactionCoaFilterType.RULE },
    { label: "Kick", option: TransactionCoaFilterType.KICK },
];

interface Props extends BaseFilterProps {
    hideLastChangedBy?: boolean;
}

export const CoaAccountFilter: React.FC<Props> = ({
    filters,
    onChange,
    hideLastChangedBy = false,
}) => {
    const { data: chartOfAccounts } = useChartOfAccountsQuery();

    const onTypeChange = useCallback(
        (type: TransactionCoaFilterType) => {
            let value =
                filters.coaFilterType ??
                coaFilterSettings.map((item) => item.option);
            if (value.includes(type)) {
                value = value.filter((item) => item !== type);
            } else {
                value = [...value, type];
            }
            onChange({
                coaFilterType: value.length ? value : undefined,
            });
        },
        [onChange, filters.coaFilterType],
    );

    return (
        <CoaAccountList
            accounts={chartOfAccounts?.accounts}
            groups={chartOfAccounts?.groups}
            entityIds={filters.entityIds}
            selectedIds={filters.coaAccounts}
            onSelectedIdsChange={(coaAccounts) => onChange({ coaAccounts })}
            onClearAll={() => onChange({ coaAccounts: undefined })}
            footerSlot={
                !hideLastChangedBy && (
                    <>
                        <Separator block className={styles.divider} />
                        <div className={styles.typeSelectorContainer}>
                            <span className={styles.sectionHeader}>
                                Last changed by
                            </span>
                            {coaFilterSettings.map(({ label, option }) => (
                                <Checkbox
                                    key={option}
                                    name={`coaFilterType-${option}`}
                                    label={label}
                                    checked={
                                        !!filters.coaFilterType?.includes(
                                            option,
                                        ) || !filters.coaFilterType?.length
                                    }
                                    onCheckedChange={() => onTypeChange(option)}
                                />
                            ))}
                        </div>
                    </>
                )
            }
        />
    );
};
